define("shared/components/shared/post-tagging/select/tag-select-item", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.shouldShowSelectedStatus}}
    {{#if this.isSelected}}
      {{svg-jar "verified-solid" class="o--icon cPT__icon u--m__r__sm cPT__color-primary"}}
    {{else}}
      {{svg-jar "verified" class="o--icon cPT__icon u--m__r__sm"}}
    {{/if}}
  {{/if}}
  {{#if this.color}}
    <Shared::PostTagging::ColorCircle @class="u--m__r__sm" @color={{this.color}} />
  {{/if}}
  <span class={{concat-classes "tag-name" "u--m__r__xs"}}>{{this.displayValue}}</span>
  */
  {
    "id": "TcB1ub9h",
    "block": "[[[41,[30,0,[\"shouldShowSelectedStatus\"]],[[[41,[30,0,[\"isSelected\"]],[[[1,\"    \"],[1,[28,[35,1],[\"verified-solid\"],[[\"class\"],[\"o--icon cPT__icon u--m__r__sm cPT__color-primary\"]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,1],[\"verified\"],[[\"class\"],[\"o--icon cPT__icon u--m__r__sm\"]]]],[1,\"\\n\"]],[]]]],[]],null],[41,[30,0,[\"color\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@class\",\"@color\"],[\"u--m__r__sm\",[30,0,[\"color\"]]]],null],[1,\"\\n\"]],[]],null],[10,1],[15,0,[28,[37,3],[\"tag-name\",\"u--m__r__xs\"],null]],[12],[1,[30,0,[\"displayValue\"]]],[13]],[],false,[\"if\",\"svg-jar\",\"shared/post-tagging/color-circle\",\"concat-classes\"]]",
    "moduleName": "shared/components/shared/post-tagging/select/tag-select-item.hbs",
    "isStrictMode": false
  });
  class TagSelectItemComponent extends _component2.default {
    get isSelected() {
      return this.args.select.selected.includes(this.args.item);
    }
    get shouldShowSelectedStatus() {
      return this.args.showSelectedStatusIcon ?? true;
    }
    get color() {
      if (this.args.item.value === 'string') return undefined;
      const item = this.args.item.value;
      return item.data?.color;
    }
    get displayValue() {
      return this.args.item.name;
    }
  }
  _exports.default = TagSelectItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TagSelectItemComponent);
});